<template>
    <div
        id="be-elenco-listini"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />

            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-5">
                                <h1 class="mb-0">{{ $t("Listini") }}</h1>
                            </div>
                            <div class="col-sm-7 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <button
                                            type="button"
                                            class="pulsante-nuovo-listino btn btn-primary btn-rikorda1"
                                            v-b-modal.new-pricelist-modal
                                        >
                                            {{ $t("Nuovo listino") }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid">
                    <ul class="elenco-listini row d-flex justify-content-start flex-wrap">
                        <li
                            class="col-sm-6 col-md-4 col-lg-3 mt-3 d-flex justify-content-end flex-column mb-0"
                            v-for="pricelist in pricelists"
                            :key="pricelist.idListino"
                        >
                            <div
                                class="pricelist border bg-white h-100 d-flex justify-content-between flex-column flex-wrap"
                                @click.prevent="
                                    goToPricelist(pricelist.idListino)
                                "
                            >
                                <div class="p-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="data col-12 pr-0 pl-0 small text-right">
                                            <span class="d-inline-block">{{ $t("Creato") }}:</span>
                                            &nbsp;
                                            <span class="d-inline-block">{{
                                                pricelist.dataCreazione
                                                    | formatDate
                                            }}</span>
                                        </span>
                                    </div>
                                    <span class="titolo d-block mt-3"><a href="#">{{
                                            pricelist.nome
                                        }}</a></span>
                                    <p class="mb-0 mt-1 small">
                                        {{ pricelist.articlesCount }}
                                        {{ $t("articoli") }}
                                    </p>
                                </div>
                                <p class="alert alert-dark mb-0 py-1 px-3 rounded-0">
                                    <font-awesome-icon :icon="['fas', 'link']" />
                                    {{ $tc("backend.pricelists.usedInEventsLabel", pricelist.usedInEvents, {usedInEvents: pricelist.usedInEvents}) }}
                                </p>
                            </div>

                            <b-dropdown
                                variant="light border rounded-0"
                                dropup
                                block
                                class=""
                                menu-class="w-100 text-center"
                            >
                                <template v-slot:button-content>
                                    {{ $t("Azioni") }}
                                </template>
                                <b-dropdown-item @click.prevent="showPricelistAssignToEventsModal(pricelist.idListino)">
                                    {{ $t("Assegna a galleria") }}
                                </b-dropdown-item>
                                <b-dropdown-item @click.prevent="goToPricelist(pricelist.idListino)">
                                    {{ $t("Modifica") }}
                                </b-dropdown-item>
                                <b-dropdown-item @click.prevent="duplicatePricelist(pricelist)">
                                    {{ $t("Duplica") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                    variant="danger"
                                    v-show="pricelist.usedInEvents == 0"
                                    @click.prevent="showDeletePricelistModal(pricelist)"
                                >
                                    {{$t("Elimina") }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </li>
                    </ul>
                </div>
            </main>

            <backend-footer />

            <!-- popup nuovo listino -->
            <validation-observer v-slot="{ handleSubmit }">
                <b-modal
                    id="new-pricelist-modal"
                    title="Nuovo listino"
                    @show="resetNewPricelistModal"
                    @hidden="resetNewPricelistModal"
                >

                    <div class="form-row mt-3">
                        <div class="col-sm-12">
                            <label for="newPricelistName">{{ $t("Nome") }}</label>
                            <validation-provider
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <input
                                    type="text"
                                    class="form-control"
                                    id="newPricelistName"
                                    v-model="newPricelist.name"
                                /><small class="text-danger">{{errors[0]}}</small>
                            </validation-provider>

                        </div>
                    </div>

                    <div class="form-row mt-3">
                        <div class="col-sm-12">
                            <div class="col-sm-12 text-center alert alert-dark mb-0 py-1 px-3 rounded-0 font-weight-bold">
                                <label
                                    class="mt-0"
                                    for="pricelist-type"
                                >{{ $t("Nuovo o da Default") }}
                                    <font-awesome-icon
                                        :icon="['fas', 'question-circle']"
                                        title="?"
                                        class="ml-1"
                                        v-b-modal.pricelist-help-modal
                                    />
                                </label>
                            </div>
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                    id="pricelist-type"
                                    v-model="newPricelist.type"
                                    :aria-describedby="ariaDescribedby"
                                    name="pricelist-type"
                                    class="pt-2 pl-2"
                                >
                                    <b-form-radio
                                        class="col-sm-5 ml-2"
                                        value="DEFAULT"
                                    >Copia da listino default</b-form-radio>
                                    <b-form-radio
                                        class="col-sm-5 ml-2"
                                        value="FREE"
                                    >Crea nuovo listino libero</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>

                    <div
                        class="form-row mt-3"
                        v-show="newPricelist.type == 'FREE'"
                    >
                        <div class="col-sm-12">
                            <div class="col-sm-12 text-center alert alert-dark mb-0 py-1 px-3 rounded-0 font-weight-bold">
                                <label
                                    class="mt-0"
                                    for="pricelist-ratio"
                                >{{ $t("Proporzione base/altezza foto") }}
                                    <font-awesome-icon
                                        :icon="['fas', 'question-circle']"
                                        title="?"
                                        class="ml-1"
                                        v-b-modal.ratio-help-modal
                                    />
                                </label>
                            </div>
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                    id="pricelist-ratio"
                                    v-model="newPricelist.ratio"
                                    :aria-describedby="ariaDescribedby"
                                    name="radio-sub-component"
                                    class="pt-2 pl-2"
                                >
                                    <b-form-radio
                                        class="col-sm-12 ml-2"
                                        value="1"
                                    >{{ $t("1/1 (esempio 30x30)") }}</b-form-radio>
                                    <b-form-radio
                                        class="col-sm-12 ml-2"
                                        value="1.5"
                                    >{{ $t("2/3 (esempio 30x45)") }}</b-form-radio>
                                    <b-form-radio
                                        class="col-sm-12 ml-2"
                                        value="1.33"
                                    >{{ $t("4/3 (esempio 30x40)") }}</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>

                    <template v-slot:modal-footer="{ ok, cancel }">
                        <b-button
                            class="btn btn-light border"
                            @click="cancel()"
                        >
                            {{ $t("Annulla") }}
                        </b-button>
                        <b-button
                            class="btn btn-primary btn-rikorda1"
                            @click.prevent="handleSubmit(createNewPricelist)"
                        >
                            {{ $t("Aggiungi") }}
                        </b-button>
                    </template>
                </b-modal>
            </validation-observer>

            <!-- popup help tipo listino default/free -->
            <b-modal
                id="pricelist-help-modal"
                title="“Copia da listino di default” o “Crea Nuovo listino libero” ?"
                size="xl"
                ok-only
            >
                <p class="my-4 text-justify">
                    Selezionando <span class="font-weight-bold">“Copia da listino di default”</span> verrà creato in automatico un listino con alcuni articoli standard
                    (stampe professionali opache non corrette con profilo colore originale e proporzioni 2/3).
                </p>
                <p class="my-4 text-justify">
                    Selezionando <span class="font-weight-bold">“Crea nuovo listino libero”</span> avrai la possibilità di creare da zero il tuo listino impostando le
                    categorie come meglio desideri ed includendo qualsiasi tipo di stampa: lucida opaca o fine art, con il tipo di
                    correzione che meglio desideri (correzione con operatore, autocorretta o con profilo colore originale) e tutti
                    i formati che desideri (nelle proporzioni 2/3, 4/3 e quadrate).
                </p>

                <template v-slot:modal-footer="{ ok }">
                    <b-button
                        class="btn btn-primary btn-rikorda1 btn-secondary"
                        @click="ok()"
                    >
                        {{ $t("Chiudi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup help proporzione formato in listino -->
            <b-modal
                id="ratio-help-modal"
                title="Rapporto base/altezza foto"
                size="xl"
                ok-only
            >
                <p class="my-4 text-justify">
                    Ti permette di indicare il rapporto base/altezza delle tue foto in modo da impostare un filtro sui formati ed avere
                    solo la selezione dei formati più adatta alle tue foto.
                </p>
                <p class="my-4 text-justify">
                    Serve inoltre ad impostare un inquadratura uniforme tra tutte le immagini in modo da avere la sicurezza che in stampa
                    si ottenga l’inquadratura vista in preview.
                </p>

                <template v-slot:modal-footer="{ ok }">
                    <b-button
                        class="btn btn-primary btn-rikorda1 btn-secondary"
                        @click="ok()"
                    >
                        {{ $t("Chiudi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup cancellazione listino -->
            <b-modal
                id="delete-pricelist-modal"
                title="Cancella il listino"
                @ok="deletePricelist"
            >
                <p class="mb-0">
                    {{ $t("Sei sicuro di voler cancellare il listino") }} "{{ pricelistToDelete.nome }}"?
                </p>
                <p class="mb-0 mt-1">
                    {{ $t("Il listino non sarà più accessibile. Questa azione non può essere annullata!") }}
                </p>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-danger"
                        @click="ok()"
                    >
                        {{ $t("Elimina") }}
                    </b-button>
                </template>
            </b-modal>

            <pricelist-assign-to-events-modal
                ref="pricelistAssignToEventsModal"
                :pricelist-id="pricelistIdToAssignToEvents"
                @close="hidePricelistAssignToEventsModal"
            />
        </div>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";
import PricelistAssignToEventsModal from "../../../components/backend/PricelistAssignToEventsModal";

export default {
    name: "BackendPricelists",

    components: {
        ValidationObserver,
        ValidationProvider,
        BackendHeader,
        BackendFooter,
        PricelistAssignToEventsModal
    },

    data() {
        return {
            pricelists: [],

            newPricelist: {
                name: "",
                type: "DEFAULT",
                ratio: 1.5
            },

            pricelistToDelete: {},
            pricelistIdToAssignToEvents: ""
        };
    },

    mounted() {
        extend("required", {
            ...required,
            message: "Questo campo è obbligatorio"
        });

        if (this.$store.getters.isAgent) {
            this.$router.push({
                name: "backend-dashboard"
            });
        } else {
            this.loadPricelists();
        }
    },

    methods: {
        loadPricelists() {
            return this.$api
                .backendGetPricelists()
                .then((result) => {
                    console.debug("BACKEND_GET_PRICE_LISTS", result);
                    if (result.pricelists) {
                        this.pricelists = result.pricelists;
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_GET_PRICE_LISTS", error);
                });
        },

        resetNewPricelistModal() {
            this.newPricelist.name = "";
            this.newPricelist.type = "DEFAULT";
            this.newPricelist.ratio = 1.5;
        },

        createNewPricelist() {
            if (this.newPricelist.name.length > 0) {
                this.$api
                    .backendCreatePricelist(this.newPricelist)
                    .then((response) => {
                        console.log("BACKEND_CREATE_PRICELIST", response);
                        if (
                            response.pricelistId &&
                            response.pricelistId.length > 0
                        ) {
                            this.resetNewPricelistModal();
                            this.goToPricelist(response.pricelistId);
                        }
                    })
                    .catch((error) => {
                        console.error("BACKEND_CREATE_PRICELIST", error);
                    });
            }
        },

        duplicatePricelist(pricelistToClone) {
            var pricelist = {
                name: pricelistToClone.nome,
                pricelistIdToClone: pricelistToClone.idListino,
                type: pricelistToClone.tipoListino,
                ratio: pricelistToClone.rapporto
            };

            this.$api
                .backendCreatePricelist(pricelist)
                .then((response) => {
                    console.log("BACKEND_CREATE_PRICELIST", response);
                    if (
                        response.pricelistId &&
                        response.pricelistId.length > 0
                    ) {
                        this.loadPricelists();
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_CREATE_PRICELIST", error);
                });
        },

        showDeletePricelistModal(pricelist) {
            this.pricelistToDelete = pricelist;
            this.$bvModal.show("delete-pricelist-modal");
        },

        deletePricelist() {
            if (this.pricelistToDelete.idListino.length > 0) {
                this.$api
                    .backendDeletePricelist(this.pricelistToDelete.idListino)
                    .then(() => {
                        for (var i = 0; i < this.pricelists.length; i++) {
                            if (
                                this.pricelists[i].idListino ===
                                this.pricelistToDelete.idListino
                            ) {
                                this.pricelists.splice(i, 1);
                                break;
                            }
                        }
                    });
            }
        },

        showPricelistAssignToEventsModal(pricelistId) {
            this.pricelistIdToAssignToEvents = pricelistId;
            this.$nextTick(function () {
                this.$bvModal.show("pricelist-assign-to-events-modal");
                return this.$refs.pricelistAssignToEventsModal.load();
            });
        },

        hidePricelistAssignToEventsModal(params) {
            if (params.update) {
                this.loadPricelists();
            }
        },

        goToPricelist(pricelistId) {
            this.$router.push({
                name: "backend-sales-pricelist",
                params: { pricelistId: pricelistId }
            });
        }
    }
};
</script>

<style scoped>
.elenco-listini .pricelist {
    cursor: pointer;
}
</style>
